module.exports = __webpack_public_path__ + "img/horizontal_3_1_8011.c1b94fef.png";